import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import TableSkeleton from "@/app/components/ui/Skeletons/TableSkeleton";
import { useInventoryManufacturereListAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryManufacturereListAPI";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import { useLoader } from "@/app/hooks/useLoader";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IInventoryState, setManufacturerDetails } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useEffect, useState } from "react";
import { FaProductHunt } from "react-icons/fa6";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ManufacturerActiveDeactiveComponent from "../ManufacturerActiveDeactiveComponent";
import InputWithAddOn from "@/app/components/ui/Inputs/InputWithAddOn";

const ManufacturerListComponent = () => {
  const { NO_PWL_RESULTS } = useImageConstants();
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("INVENTORY", "id");
  const { routeState } = useRouteInfo(routeId);
  const dispatch = useDispatch();
  const { manufacturerList } = routeState.state as IInventoryState;
  const fetchBatchListAPI = useInventoryManufacturereListAPI();
  const isManufacturerListLoading = useLoader("isManufacturereListLoadingInProgress");
  const [searchQuery, setSearchQuery] = useState<string>("");

  useEffect(() => {
    fetchBatchListAPI(searchQuery);
    dispatch(setManufacturerDetails({ data: null }));
  }, [searchQuery]);

  const navigate = useNavigate();

  const handelEditNavigate = (id: string) => {
    navigate(`/app/inventory/manufacture-add?manufacture_id=${id}`);
  };

  return (
    <div className="mt-4 flow-root px-3">
      <div className="mb-3">
        <InputWithAddOn
          onEnterKeyPress={(query: string) => setSearchQuery(query)}
          containerClassName="w-full sm:w-1/2 lg:w-1/3"
          addon={<FaProductHunt className="w-4 h-4" />}
          placeholder="Search Manufacturer"
        />
      </div>
      {isManufacturerListLoading ? (
        <TableSkeleton />
      ) : manufacturerList?.length === 0 ? (
        <NoDataFoundComponent
          imageURL={NO_PWL_RESULTS}
          message="No Service Listed"
          description="No Service  Listed, please onboard some service."
        />
      ) : (
        <div className="-mx-4 mt-5 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 ">
                      SN
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Name
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Status
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {manufacturerList?.map((value, idx) => (
                    <tr key={value?.manufacturer_name}>
                      <td className="whitespace-nowrap px-3 py-3.5 text-sm font-medium text-gray-900  ">{idx + 1}</td>
                      <td className="whitespace-nowrap px-3 py-3.5 text-sm font-medium text-gray-900 ">
                        {value?.manufacturer_name}
                      </td>
                      <td className="whitespace-nowrap px-3 py-3.5 text-sm font-medium text-gray-900 ">
                        <ManufacturerActiveDeactiveComponent
                          flage={value?.status}
                          manufacturer_id={value?.manufacturer_id}
                        />
                      </td>
                      <td className="text-xs text-left p-3 cursor-pointer">
                        <PencilSquareIcon
                          className="w-5 h-5"
                          onClick={() => handelEditNavigate(value?.manufacturer_id)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ManufacturerListComponent;
